(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
// ?? Quantity sync ????????????????????????????????????????????????????????????
// The qty inputs (main buy box + sticky bar) live OUTSIDE the form element,
// linked via the `form` attribute. QuantitySelector's +/? buttons update the
// value via a JS setter that fires no DOM events, so we intercept clicks on
// the +/? buttons and sync all sibling qty inputs after the setter runs.
(function() {
  function syncQtyInputs(sourceInput) {
    var formId = sourceInput.getAttribute('form');
    if (!formId) return;
    var all = document.querySelectorAll('[name="quantity"][form="' + formId + '"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== sourceInput) all[i].value = sourceInput.value;
    }
  }
  // +/? button: poll once after the setter has fired
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('.quantity-selector__button');
    if (!qtyBtn) return;
    setTimeout(function() {
      var qs = qtyBtn.closest('quantity-selector');
      var input = qs && qs.querySelector('[name="quantity"]');
      if (input) syncQtyInputs(input);
    }, 0);
  });
  // Direct keyboard / paste input
  document.addEventListener('input', function(e) {
    if (e.target.name === 'quantity') syncQtyInputs(e.target);
  });
})();

// ?? Buy Now ??????????????????????????????????????????????????????????????????
// Capture-phase click so we intercept before the browser fires a submit event.
// Reads the synced qty from the form-associated inputs (all kept in sync above).
document.addEventListener('click', async function(e) {
  var btn = e.target.closest('button[name="checkout"]');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var formId = btn.getAttribute('form') || (btn.closest('form') && btn.closest('form').id);
  var form   = formId ? document.getElementById(formId) : btn.closest('form');
  if (!form) return;

  var variantId = form.elements['id'] && form.elements['id'].value;
  if (!variantId) return;

  // All qty inputs are kept in sync; just grab the first one by form-attr.
  var qtyInput = formId
    ? document.querySelector('[name="quantity"][form="' + formId + '"]')
    : form.querySelector('[name="quantity"]');
  var quantity = parseInt(qtyInput && qtyInput.value) || 1;

  btn.setAttribute('disabled', '');
  btn.setAttribute('aria-busy', 'true');

  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    });
    if (res.ok) {
      window.location.href = '/checkout';
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-busy');
    }
  } catch (_) {
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-busy');
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protec-about-editorial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var scope = document.querySelector('.pae');
    if(!scope) return;
    var links = scope.querySelectorAll('[data-pae-link]');
    var chapters = scope.querySelectorAll('[data-pae-chapter]');
    if(!chapters.length || !links.length) return;
    var map = {};
    for(var i=0;i<links.length;i++){ map[links[i].getAttribute('data-pae-link')] = links[i]; }
    function activate(id){ for(var i=0;i<links.length;i++){ links[i].classList.remove('is-active'); } if(map[id]) map[id].classList.add('is-active'); }
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ activate(e.target.getAttribute('data-pae-chapter')); } });
      }, { rootMargin: '-28% 0px -62% 0px', threshold: 0 });
      chapters.forEach(function(c){ io.observe(c); });
    } else {
      activate(chapters[0].getAttribute('data-pae-chapter'));
    }
    links.forEach(function(l){ l.addEventListener('click', function(ev){ ev.preventDefault(); var t = document.getElementById(l.getAttribute('data-pae-link')); if(t){ t.scrollIntoView({behavior:'smooth', block:'start'}); } }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protec-pdp"]) return;
  try {
    
  (function () {
    var main = document.querySelector('[data-pdp-main]');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-pdp-thumb');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
